import { render, staticRenderFns } from "./acidDocumentsAdmin.vue?vue&type=template&id=142a2033&scoped=true"
import script from "./acidDocumentsAdmin.vue?vue&type=script&lang=ts"
export * from "./acidDocumentsAdmin.vue?vue&type=script&lang=ts"
import style0 from "./acidDocumentsAdmin.vue?vue&type=style&index=0&id=142a2033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142a2033",
  null
  
)

export default component.exports